<template>
  <div class="flowDtl_box">
    <el-dialog
      v-model="dialogVisible"
      :width="showSlotFlag ? 'calc(100% - 250px)' : '70%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="20px"
      @closed="closeDaliogFunc"
      v-if="hasModal"
    >
      <template #header>
        <div class="dialog-header">
          <div class="dialog_paging">
            <el-tooltip class="item" effect="dark" content="上一条" placement="bottom" >
              <i
                class="iconfont icon-left1"
                @click="indexChange(-1)"
              ></i>
            </el-tooltip>
            <span class="text">{{curIndex+1}} / {{curTotal}}</span>
            <el-tooltip class="item" effect="dark" content="下一条" placement="bottom" >
              <i
                class="iconfont icon-down1"
                @click="indexChange(1)"
              ></i>
            </el-tooltip>
          </div>
          {{dtlTitle.replace('-undefined','')}}
          <div class="dialog_header_icon">
            <el-tooltip effect="dark" v-if="!showSlotFlag" content="展开" placement="bottom">
              <i
                class="iconfont icon-zhankai"
                @click="showSlotFlag = !showSlotFlag"
                
              ></i>
            </el-tooltip>
            <el-tooltip v-if="showSlotFlag" effect="dark" content="收起" placement="bottom">
              <i
                class="iconfont icon-shousuo"
                @click="showSlotFlag = !showSlotFlag"
                
              ></i>
            </el-tooltip>
          </div>
        </div>
      </template>
      <div class="flowDtlBox_content" v-cstloading="isloading" >
        <div
          class="flowDtlBox_content_box"
          :style="!showSlotFlag ? 'width:100%' : ''"
          v-if="!isloading"
        >
        <el-scrollbar  height="calc(100% - 50px)">
          <div class="flowDtlBox_content_contentBox" :style="curScene=='HITASK'||isFinsh?'height:100%':''"  :class="layoutMode == 'LEFTRIGHT'?'dtlForm_leftRight':''">
            <div
              v-for="(lineId, lineIndex) of layout.lineIds"
              :data="lineId"
              :key="lineIndex"
              class="formDesigner_centerBox_relativeBox"
              :class="
                layout.lines[lineId].type == 'TAB' ||
                layout.lines[lineId].type == 'COLLAPSE'
                  ? 'formDesigner_centerBox_lineBox'
                  : ''
              "
            >
              <div
                v-if="layout.lines[lineId].type == 'FENCE'"
                :style="layoutMode == 'UPDOWN'? '': 'padding:0 12px;width:calc(100% - 24px);'"
              >
                <div class="tableBox">
                  <div
                    :key="colIndex"
                    v-for="(colItem, colIndex) of layout.lines[lineId].set.cols"
                    class="colItemStyle"
                    :style="computedWidth(colItem,layout.lines[lineId].set.cols.length)"
                    :class="layoutMode == 'UPDOWN' ? '' : 'border_box_top'"
                  >
                    <div
                      v-for="(domItem, rowIndex) of colItem.rows"
                      :key="rowIndex"
                      class="animoStyle"
                      :class="layoutMode == 'UPDOWN' ? '' : 'border_box_left'"
                    >
                      <div class="rowStyle" v-if="computeFldAuth(domItem.fldId)!='HIDDEN'">
                        <div class="domStyle" :style="layoutMode == 'UPDOWN'?'':'padding:0px;'">
                          <div class="domSpanBox">
                            <component
                              :id="'tblFLds_'+domItem.fldId"
                              :auth="computeFldAuth(domItem.fldId)"
                              :is="'QS' + flds[domItem.fldId].type + 'FLD'"
                              v-model="dtlRowData[domItem.fldId]"
                              :layoutMode="layoutMode"
                              :scene="taskType==50 || taskType == 60?'FORM':'PCDTL'"
                              :fldObj="flds[domItem.fldId]"
                              :rowId="dtlRowData._id"
                              :rowData="dtlRowData"
                              :tblId="wtId"
                            ></component>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="layout.lines[lineId].type == 'TAB'  && !(layout.lines[lineId].set.config.attr == 'hideAlways')"
                class="formDesigner_lineBox_relativeBox"
              >
                <el-tabs
                  v-model="layout.lines[lineId].set.curTabId"
                  :type="layout.lines[lineId].set.config.style == 'NAV'? '': 'border-card'"
                  :class="layout.lines[lineId].set.config.style == 'NAV'? 'formDesigner_lineBox_Nav_Box': 'formDesigner_lineBox_Tab_Box'"
                >
                  <el-tab-pane
                    v-for="(tabItem, tabIndex) of layout.lines[lineId].set.tabList"
                    :key="tabIndex"
                    :label="tabItem.config.tabName"
                    :name="tabItem.config.tabId"
                  >
                    <div class="tabTableBox">
                      <div
                        v-for="(tabLineId, childLineIndex) of tabItem.lines"
                        :key="childLineIndex"
                        class="formDesigner_centerBox_relativeBox formDesigner_lineBox_relativeBox"
                      >
                        <div
                          class="tabLineBox"
                          v-if="layout.lines[tabLineId].type == 'FENCE'"
                          :style="layoutMode == 'UPDOWN'? '': 'padding:0 12px;width:calc(100% - 24px);'"
                        >
                          <div
                            :key="colIndex"
                            v-for="(colItem, colIndex) of layout.lines[tabLineId].set.cols"
                            class="colItemStyle"
                            :style="computedWidth(colItem,layout.lines[tabLineId].set.cols.length)"
                            :class="layoutMode == 'UPDOWN' ? '' : 'border_box_top'"
                          >
                            <div
                              v-for="(domItem, rowIndex) of colItem.rows"
                              :key="domItem.fldId + rowIndex"
                              class="animoStyle"
                              :class="layoutMode == 'UPDOWN' ? '' : 'border_box_left'"
                            >
                              <div class="rowStyle" v-if="computeFldAuth(domItem.fldId)!='HIDDEN'">
                                <div class="domStyle" :style="layoutMode == 'UPDOWN'?'':'padding:0px;'">
                                  <div class="domSpanBox">
                                    <component
                                      :auth="computeFldAuth(domItem.fldId)"
                                      :is="'QS' + flds[domItem.fldId].type + 'FLD'"
                                      v-model="dtlRowData[domItem.fldId]"
                                      :layoutMode="layoutMode"
                                      :scene="taskType==50 || taskType == 60?'FORM':'PCDTL'"
                                      :fldObj="flds[domItem.fldId]"
                                      :rowId="dtlRowData._id"
                                      :rowData="dtlRowData"
                                      :tblId="wtId"
                                       :id="'tblFLds_'+domItem.fldId"
                                    ></component>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="tabBox_inner_collapse"
                          v-if="layout.lines[tabLineId].type == 'COLLAPSE' && !(layout.lines[tabLineId].set.config.attr == 'hideAlways')"
                        >
                          <el-collapse
                            v-model="layout.lines[tabLineId].set.status"
                            accordion
                            :class="layout.lines[tabLineId].set.config.allowCollapse? '': 'noAllowCollapse'"
                          >
                            <el-collapse-item
                              :name="layout.lines[tabLineId].set.config.name"
                            >
                              <template #title>
                                <div
                                  class="collopase_title_box"
                                  @click.stop="layout.lines[tabLineId].set.status = layout.lines[tabLineId].set.status? '': layout.lines[tabLineId].set.config.name"
                                >
                                <div v-if="layout.lines[tabLineId].set.config.layout == 'center'"></div>
                                  <div :style="layout.lines[tabLineId].set.config.icon?'':'padding-left:24px;'">
                                    <i
                                      v-if="layout.lines[tabLineId].set.config.icon"
                                      :class="'iconfont '+layout.lines[tabLineId].set.config.icon"
                                    ></i>{{layout.lines[tabLineId].set.config.name}}
                                  </div>
                                  <div
                                    class="collapse_icon_box"
                                    v-if="layout.lines[tabLineId].set.config.allowCollapse"
                                  >
                                    <i
                                      v-if="layout.lines[tabLineId].set.status"
                                      @click.stop="layout.lines[tabLineId].set.status = ''"
                                      class="iconfont icon-down"
                                      style="color: #575757;font-size: 18px;margin-right: 15px;"
                                    ></i>
                                    <i
                                      v-else
                                      @click.stop="layout.lines[tabLineId].set.status=layout.lines[tabLineId].set.config.name"
                                      class="iconfont icon-arrow-down-new"
                                      style="
                                        color: #575757;
                                        font-size: 18px;
                                        margin-right: 15px;
                                      "
                                    ></i>
                                  </div>
                                </div>
                              </template>
                              <div class="shrinkBox">
                                <div
                                  v-for="(cLineId, childLineIndex) of layout
                                    .lines[tabLineId].set.lines"
                                  :key="childLineIndex"
                                  class="formDesigner_centerBox_relativeBox"
                                >
                                  <div
                                    class="tabLineBox"
                                    :style="layoutMode == 'UPDOWN'? '': 'padding:0 12px;width:calc(100% - 24px);'"
                                  >
                                    <div
                                      :key="colIndex"
                                      v-for="(colItem, colIndex) of layout.lines[cLineId].set.cols"
                                      class="colItemStyle"
                                      :style="computedWidth(colItem,layout.lines[cLineId].set.cols.length)"
                                      :class="layoutMode == 'UPDOWN'? '': 'border_box_top'"
                                    >
                                      <div
                                        v-for="(domItem, rowIndex) of colItem.rows"
                                        :key="rowIndex"
                                        class="animoStyle"
                                        :class="layoutMode == 'UPDOWN'? '': 'border_box_left'"
                                      >
                                        <div class="rowStyle" v-if="computeFldAuth(domItem.fldId)!='HIDDEN'">
                                          <div class="domStyle" :style="layoutMode == 'UPDOWN'?'':'padding:0px;'">
                                            <div class="domSpanBox">
                                              <component
                                                :auth="computeFldAuth(domItem.fldId)"
                                                :is="'QS' +flds[domItem.fldId].type +'FLD'"
                                                v-model="dtlRowData[domItem.fldId]"
                                                :layoutMode="layoutMode"
                                                :scene="taskType==50 || taskType == 60?'FORM':'PCDTL'"
                                                :fldObj="flds[domItem.fldId]"
                                                :rowId="dtlRowData._id"
                                                :rowData="dtlRowData"
                                                :tblId="wtId"
                                                 :id="'tblFLds_'+domItem.fldId"
                                              ></component>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div
                v-if="layout.lines[lineId].type == 'COLLAPSE' && !(layout.lines[lineId].set.config.attr == 'hideAlways')"
                class="formDesigner_lineBox_relativeBox"
              >
                <el-collapse
                  v-model="layout.lines[lineId].set.status"
                  accordion
                  :class="layout.lines[lineId].set.config.allowCollapse ? '' : 'noAllowCollapse'"
                >
                  <el-collapse-item
                    :name="layout.lines[lineId].set.config.name"
                  >
                    <template #title>
                      <div
                        class="collopase_title_box"
                        @click.stop="layout.lines[lineId].set.status = layout.lines[lineId].set.status? '': layout.lines[lineId].set.config.name"
                      >
                        <div v-if="layout.lines[lineId].set.config.layout == 'center'"></div>
                        <div :style="layout.lines[lineId].set.config.icon?'':'padding-left:24px;'">
                          <i
                            v-if="layout.lines[lineId].set.config.icon"
                            :class="'iconfont ' + layout.lines[lineId].set.config.icon"
                          ></i>
                          {{ layout.lines[lineId].set.config.name }}
                        </div>
                        <div
                          class="collapse_icon_box"
                          v-if="layout.lines[lineId].set.config.allowCollapse"
                        >
                          <i
                            v-if="layout.lines[lineId].set.status"
                            @click.stop="layout.lines[lineId].set.status = ''"
                            class="iconfont icon-down"
                            style="
                              color: #575757;
                              font-size: 18px;
                              margin-right: 15px;
                            "
                          ></i>
                          <i
                            v-else
                            @click.stop="layout.lines[lineId].set.status =layout.lines[lineId].set.config.name"
                            class="iconfont icon-arrow-down-new"
                            style="
                              color: #575757;
                              font-size: 18px;
                              margin-right: 15px;
                            "
                          ></i>
                        </div>
                      </div>
                    </template>
                    <div class="shrinkBox">
                      <div
                        v-for="(tabLineId, childLineIndex) of layout.lines[lineId].set.lines"
                        :key="childLineIndex"
                        class="formDesigner_centerBox_relativeBox"
                      >
                        <div
                          class="tabLineBox"
                          :style="layoutMode == 'UPDOWN'? '': 'padding:0 12px;width:calc(100% - 24px);'"
                        >
                          <div
                            :key="colIndex"
                            v-for="(colItem, colIndex) of layout.lines[tabLineId].set.cols"
                            class="colItemStyle"
                            :style="computedWidth(colItem,layout.lines[tabLineId].set.cols.length)"
                            :class="layoutMode == 'UPDOWN' ? '' : 'border_box_top'"
                          >
                            <div
                              v-for="(domItem, rowIndex) of colItem.rows"
                              :key="rowIndex"
                              class="animoStyle"
                              :class="layoutMode == 'UPDOWN' ? '' : 'border_box_left'"
                            >
                              <div class="rowStyle" v-if="computeFldAuth(domItem.fldId)!='HIDDEN'">
                                <div class="domStyle" :style="layoutMode == 'UPDOWN'?'':'padding:0px;'">
                                  <div class="domSpanBox">
                                    <component
                                      :auth="computeFldAuth(domItem.fldId)"
                                      :is="'QS' + flds[domItem.fldId].type + 'FLD'"
                                      v-model="dtlRowData[domItem.fldId]"
                                      :layoutMode="layoutMode"
                                      :scene="taskType==50 || taskType == 60?'FORM':'PCDTL'"
                                      :fldObj="flds[domItem.fldId]"
                                      :rowId="dtlRowData._id"
                                      :rowData="dtlRowData"
                                      :tblId="wtId"
                                       :id="'tblFLds_'+domItem.fldId"
                                    ></component>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </el-scrollbar>
          <div v-if="curScene!='HITASK'">
            <!-- 发起人撤回 -->
            <div class="dialog_bottom_btn_box" v-if="curScene=='FLOW'&&!isFinsh">
              <span class="dialog-footer" v-if="flowBaseSet">
                <el-button  type="primary" @click="revoke" v-if="flowBaseSet.creatorOp.isRecall && canDoSet.reCallCanDo">
                  <i class="iconfont icon-chehui"></i>
                  撤回
                </el-button>
                <el-button  type="primary" @click="rescind" v-if="flowBaseSet.creatorOp.isRescind && canDoSet.reScindCanDo">
                  <i class="iconfont icon-chehui"></i>
                  撤销
                </el-button>
                <el-button  type="primary" @click="urge" v-if="flowBaseSet.creatorOp.isUrge">
                  催办
                </el-button>
              </span>
            </div>
            <div class="dialog_bottom_btn_box" v-if="taskType">
              <span class="dialog-footer" v-if="taskType!=60">
                <!-- 审批同意 -->
                <el-button
                  type="primary"
                  @click="showSuccDlg"
                  v-if="auditConfig&&taskType==10"
                  style="background-color:#4caf50;"
                >
                  <i class="iconfont icon-tongguo1"></i>
                  {{auditConfig.cstBtnSet.passBtnName}}
                </el-button>
                <!-- 审批拒绝 -->
                <el-button
                  type="primary"
                  @click="showRefDlg"
                  v-if="auditConfig&&taskType==10 && !auditConfig.banRefuse"
                  style="background-color:#f44336;"
                >
                  <i class="iconfont icon-jujue1"></i>
                  {{auditConfig.cstBtnSet.refusetBtnName}}
                </el-button>
                <!-- 拒绝加签 -->
                <el-button
                  type="primary"
                  @click="showRefAddDlg"
                  v-if="auditConfig&&taskType==10&&isAddSign"
                  style="background-color:#ffc000;"
                >
                  <i class="iconfont icon-chehui"></i>
                  退回加签人
                </el-button>
                <!-- 办理 -->
                <el-button
                  type="primary"
                  v-if="(auditConfig&&taskType==20)||taskType==50"
                  @click="showdealDlg"
                >
                  <i class="iconfont icon-bianji3"></i>
                  {{taskType==20 ? auditConfig.cstBtnSet.dealBtnName : '办理'}}
                </el-button>
                <!-- 退回 -->
                <el-popover
                  trigger="click"
                  ref="returnRef"
                  popper-class="return_popover"
                  placement="top"
                  v-if="taskType!=50 && taskType!=20 && (!examinOpObj||examinOpObj['back']|| examinOpObj['backInit']|| examinOpObj['backPNode']|| examinOpObj['backSNode'])"
                >
                  <template #reference>
                    <el-button>
                      <i class="iconfont icon-chehui"></i>
                      退回
                      <div></div>
                    </el-button>
                  </template>
                  <div class="moreBtn_list_box return_btns">
                    <div class="moreBtn_item" @click="backSponsor" v-if="examinOpObj['back'] || examinOpObj['backInit']">
                      <el-button>
                        <i class="iconfont icon-tuihuidaozhidingjiedian"></i>
                        退回到发起人
                      </el-button>
                    </div>
                    <div class="moreBtn_item" @click="backPreNode" v-if="examinOpObj['back'] || examinOpObj['backPNode']">
                      <el-button>
                        <i class="iconfont icon-tuihuidaozhidingjiedian"></i>
                        退回上一节点
                      </el-button>
                    </div>
                    <div class="moreBtn_item" @click="backNode" v-if="examinOpObj['back'] || examinOpObj['backSNode']">
                      <el-button>
                        <i class="iconfont icon-tuihuidaofaqiren"></i>
                        退回指定节点
                      </el-button>
                    </div>
                  </div>
                </el-popover>
                <!-- 更多 -->
                <el-popover
                  trigger="click"
                  ref="popRef"
                  popper-class="btn_popover"
                  placement="top-end"
                  v-if="taskType!=50 && taskType!=20 && JSON.stringify(moreBtns) != '{}'"
                >
                  <template #reference>
                    <el-button>
                      <i class="iconfont icon-gengduo"></i>
                      更多
                      <i class="iconfont icon-down-arrow"></i>
                      <div></div>
                    </el-button>
                  </template>
                  <div class="moreBtn_list_box">
                    <div
                      class="moreBtn_item"
                      v-for="(item,index) in moreBtns"
                      :key="index"
                      @click="selectOp(item.type)"
                    >
                      <el-button>
                        <i :class="item.icon"></i>
                        {{item.name}}
                      </el-button>
                    </div>
                  </div>
                </el-popover>
              </span>
              <!-- 撤回办理提交 -->
              <span class="dialog-footer" v-if="taskType==60">
                <el-button type="primary" @click="revokedeal">
                  提交
                </el-button>
              </span>
            </div>
          </div>
        </div>
        <div class="flowDtlBox_content_slotBox" v-show="showSlotFlag">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" v-if="!isloading">
            <el-tab-pane label="任务" name="task" v-if="taskCenterTaskId!==undefined&&taskCenterTaskId !== null">
              <div v-if="task" class="flowDtlBox_content_slotBox">
                <!-- 任务详情展示，复用flowDtl.vue主要结构 -->
                <div class="flowDtl_formBox">
                  <div class="flowDtl_formMainBody">
                    <!-- 任务标题 -->
                    <div class="flowDtl_task_title">
                      <div class="flowDtl_label star">任务标题</div>
                      <el-input v-model="task.task_title" placeholder="请输入任务标题" maxlength="20" show-word-limit disabled />
                    </div>
                    <!-- 负责人和分配人 -->
                    <div class="flowDtl_cAndA">
                      <div class="flowDtl_task_chargeId">
                        <div class="flowDtl_label star">任务负责人</div>
                        <div class="flowDtl_showMemSelector2">
                          <div v-if="task.task_chargeId && task.task_chargeId[0] && task.task_chargeId[0].emp_name != ''" class="flowDtl_userNameSingleBox">
                            <div class="flowDtl_userNameSingle">{{ task.task_chargeId[0].emp_name && task.task_chargeId[0].emp_name.slice ? task.task_chargeId[0].emp_name.slice(-1) : '' }}</div>
                            <text>&nbsp;{{ task.task_chargeId[0].emp_name }}</text>
                          </div>
                          <div v-else class="flowDtl_placeholder">
                            <div>请选择负责人</div>
                          </div>
                        </div>
                      </div>
                      <div class="flowDtl_task_assignId">
                        <div class="flowDtl_label star">任务分配人</div>
                        <div class="flowDtl_showMemSelector2">
                          <div class="flowDtl_userNameSingleBox">
                            <div class="flowDtl_userNameSingle">{{ task.task_assignId && task.task_assignId[0] && task.task_assignId[0].emp_name && task.task_assignId[0].emp_name.slice ? task.task_assignId[0].emp_name.slice(-1) : '' }}</div>
                            <text>&nbsp;{{ task.task_assignId && task.task_assignId[0] ? task.task_assignId[0].emp_name : '' }}</text>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 任务起止时间 -->
                    <div class="flowDtl_task_time">
                      <div class="flowDtl_label star">任务起止时间</div>
                      <div class="displayflex">
                        <el-date-picker :size="small" disabled popper-class="flowDtl_datePicker" v-model="task.task_timeArr" type="datetimerange" start-placeholder="选择开始时间" end-placeholder="选择结束时间" format="YYYY-MM-DD HH:mm:ss" date-format="YYYY/MM/DD ddd" range-separator="至" time-format="A hh:mm:ss" />
                      </div>
                    </div>
                    <!-- 附件 -->
                    <div class="flowDtl_file flowDtl_task_assignId_disable">
                      <component :is="'attachmentFld'" v-model="task.task_attach" :layoutMode="'UPDOWN'" :scene="'PCADD'" :fldObj="fldObj" auth="READONLY" />
                    </div>
                    <!-- 到期提醒和优先级 -->
                    <div class="flowDtl_rAnds">
                      <div class="flowDtl_task_remindRule">
                        <div class="flowDtl_label">到期提醒</div>
                        <div class="flowDtl_showMemSelector" style="background-color: #f5f7fa; cursor: not-allowed;">
                          <div class="flowDtl_placeholder">
                            <div>{{task.task_remindLabel}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="flowDtl_task_star">
                        <div class="flowDtl_label">优先级</div>
                        <div class="flowDtl_block" :style="{'background-color': '#f5f7fa'}">
                          <el-rate v-model="task.task_star" disabled />
                        </div>
                      </div>
                    </div>
                    <!-- 任务描述 -->
                    <div class="flowDtl_task_detail">
                      <div class="flowDtl_label">任务描述</div>
                      <el-input v-model="task.task_detail" placeholder="请输入任务详细描述" show-word-limit :rows="4" type="textarea" disabled />
                    </div>
                    <!-- 附件 -->
                    <div class="flowDtl_file flowDtl_task_assignId_disable">
                      <component :is="'attachmentFld'" v-model="task.task_attach" :layoutMode="'UPDOWN'" :scene="'PCADD'" :fldObj="fldObj1" auth="READONLY" />
                    </div>
                    <div class="flowDtl_task_title">
                      <div class="flowDtl_label star">完成描述信息</div>
                      <el-input v-model="task.task_des" disabled/>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="流转路径" name="first">
              <flowPath :fiId="fiId" v-model:isRefresh="isRefreshPath" :wtId="wtId" :rowId="dtlRowData._id"></flowPath>
            </el-tab-pane>
            <el-tab-pane label="执行协助" name="flowHelp" :disabled="bizFlowNodeId == null" v-if="scene != 'CC' && bizFlowNodeId !== null && curTaskId">
                <el-scrollbar>
                    <fileDtl :nodeId="bizFlowNodeId" :nodeDtl="bizFlowNodeDtl" :flowVerDtl="flowVerDtl"></fileDtl>
                </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane label="协作" name="second">
                <team v-if="wtId && dtlRowData._id && activeName == 'second'" @refreshData="invokerFlowDtl" :userAuth="userAuth" :rowData="dtlRowData" :wtId="wtId" :rowId="dtlRowData._id"></team>
            </el-tab-pane>
            <!-- <el-tab-pane label="流程评论" name="second">
              <comment v-if="wtId" :objType="1" :tblId="wtId" :rowId="dtlRowData._id"></comment>
            </el-tab-pane> -->
            <el-tab-pane label="催办记录" name="third">
              <div class="long_time_box" v-if="urgings.length>0">
                <div class="long_time_list_group">
                  <p class="long_time_list_group_title">
                    催办记录
                  </p>
                  <div
                    class="long_time_list_item" 
                    v-for="(item,index) of urgings" 
                    :key="index"
                  >
                    <span class="long_time_list_item_left">
                      {{item.ul_crtName}}催办
                    </span>
                    <span class="long_time_list_item_right">
                      {{item.ul_crtTime}}
                    </span>
                  </div>
                </div>
              </div>
              <el-empty v-else description="暂无催办" />
            </el-tab-pane>
            <el-tab-pane label="日志" name="rowDataLog">
                <rowDataLog v-if="wtId && dtlRowData._id && activeName == 'rowDataLog'" :tblId="wtId" :rowId="dtlRowData._id"></rowDataLog>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="flow_status" v-if="false">
        <img src="@img/flow/flowDtl/stamp1.png" alt="">
      </div>
    </el-dialog>
    <div class="dialog_box">
      <!-- 通过、拒绝、退回 -->
      <el-dialog
        v-if="succAndRefDlgVs"
        :title="succAndRefDlgData.title"
        v-model="succAndRefDlgVs"
        :width="isHasTblFlag()?'1200px':'800px'"
        :close-on-click-modal="false"
        top="5vh"
        center
        @close="closeSuccAndRefDlg"
      >
        <div class="dlg_main">
          <div class="dlg_item" v-if="succAndRefDlgData.title=='退回指定节点'">
            <div class="dlg_item_title">
              <p>回退节点</p>
            </div>
            <div class="dlg_item_c">
              <el-select v-model="succAndRefDlgData.fnId" placeholder="请选择回退节点">
                <el-option
                  v-for="(item,index) in retrunNodes"
                  :key="index"
                  :value="item.fn_id"
                  :label="item.fn_name"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="dlg_item">
            <div v-if="auditConfig.dealFldsSet && succAndRefDlgData.title != '退回到发起人' && succAndRefDlgData.title != '退回指定节点'">
                <div class="" v-for="domItem,domIndex of auditConfig.dealFldsSet.filter((zitem)=>{return fldsList[zitem.fldId]})" :key="domIndex">
                    <component :is="'QS'+fldsList[domItem.fldId].type+'FLD'" 
                    v-model="editRowData[domItem.fldId]"
                    :layoutMode="'UPDOWN'"
                    :fldObj="fldsList[domItem.fldId]"
                    :rowId="editRowData._id"
                    :scene="'PCADD'"
                    :tblId="wtId"
                    :auth="domItem.validateType == 'REQUIRED'?'EDIT': domItem.validateType"
                    :rowData="editRowData"
                    :setDefault="true"
                    ></component>
                </div>
            </div>
            <div class="dlg_item_title" v-if="(auditConfig.isOpenSuggest !== false && submitType == 'spNode') || (auditConfig.isOpenSuggest && submitType == 'dealNode') || (auditConfig.isOpenSuggest && succAndRefDlgData.title == '退回到发起人') || (auditConfig.isOpenSuggest && succAndRefDlgData.title == '退回指定节点')">
              <p><span style="color:red" v-if="auditConfig.isRequireSuggest !== false">*</span>处理意见</p>
              <div class="suggest_box">
                  <el-dropdown >
                    <div class="suggest_title">
                    <p>常用意见</p>
                    <i class="iconfont icon-down-arrow"></i>
                    </div>
                    <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item  v-for="(item,index) in offSugList" :key="index" @click="selectOffSug(item.os_content)">{{item.os_content}}</el-dropdown-item>
                        <el-dropdown-item @click="selectOffSug('同意')">同意</el-dropdown-item>
                        <el-dropdown-item @click="selectOffSug('不同意')">不同意</el-dropdown-item>
                    </el-dropdown-menu>
                    </template>
                </el-dropdown>
              </div>
            </div>
            <div class="dlg_item_c"  v-if="(auditConfig.isOpenSuggest !== false && submitType == 'spNode') || (auditConfig.isOpenSuggest && submitType == 'dealNode') || (auditConfig.isOpenSuggest && succAndRefDlgData.title == '退回到发起人') || (auditConfig.isOpenSuggest && succAndRefDlgData.title == '退回指定节点')">
              <el-input
                v-model="succAndRefDlgData.suggest"
                type="textarea"
                placeholder="请输入内容"
                :rows="10"
                @blur="suggestIptBlur"
              ></el-input>
            </div>
          </div>
          <div class="dlg_item" v-if="(succAndRefDlgData.title=='拒绝当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.refuse) || (succAndRefDlgData.title=='同意当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.pass)">
            <div class="dlg_item_title">
              <p>签名</p>
            </div>
            <div>
              <sign v-model="signFile" @resetSign="signFile=null"></sign>
            </div>
          </div>
          <div class="dlg_item">
                <div class="dlg_item_title">
                    <p>相关附件</p>
                </div>
                <div class="dlg_item_c">
                    <component :is="'attachmentFld'" v-model="succAndRefDlgData.attach" :layoutMode="'UPDOWN'" :scene="'PCADD'" :fldObj="fldObj" auth="EDIT" />
                </div>
            </div>
        </div>
        <template #footer>
          <div class="dialog_footer">
            <el-button @click="closeSuccAndRefDlg">取消</el-button>
            <el-button type="primary" plain @click="saveTaskExtraData" style="color:var(--mainColor);background:#e5f3fa">暂存</el-button>
            <el-button type="primary" @click="passAndRefuset">确认</el-button>
            <div class="dialog_footer_checkbox">
                <el-checkbox @change="changeNextFlag" v-if="taskType==10" v-model="nextSetFlag" label="继续下一个审批" />
            </div>
          </div>
        </template>
      </el-dialog>
      <!-- 1-转交、2-加签 -->
      <el-dialog
        :title="moreBtnDlgTitle"
        v-model="moreBtnDlgVs"
        width="700px"
        :close-on-click-modal="false"
        top="5vh"
        center
        @closed="clsoeOpDlg"
      >
        <div class="dlg_main">
          <div class="dlg_item">
            <div class="dlg_item_title">
              <p><span style="color:red">*</span> {{ moreEmpObj[moreBtnDlgData.type].title }}</p>
            </div>
            <div class="dlg_item_c">
              <div class="emp_box">
                <div
                  class="emp_item"
                  v-for="(item,index) in moreEmpObj[moreBtnDlgData.type].emps"
                  :key="index"
                >
                  <div class="emp_item_pic">
                    {{item.emp_name.charAt(item.emp_name.length-1)}}
                  </div>
                  <div class="emp_item_text">
                    {{item.emp_name}}
                  </div>
                  <i class="iconfont icon-close" @click="delEmp(index)"></i>
                </div>
                <div class="emp_btn" @click="openEmp">
                  <img src="@img/flow/flowConfig/add_icon.png" alt="">
                  <span>{{ moreEmpObj[moreBtnDlgData.type].name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="dlg_item">
            <div class="dlg_item_title">
              <p><span style="color:red">*</span>处理意见</p>
              <div class="suggest_box">
                  <el-dropdown >
                        <div class="suggest_title">
                        <p>常用意见</p>
                        <i class="iconfont icon-down-arrow"></i>
                        </div>
                        <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item  v-for="(item,index) in offSugList" :key="index" @click="()=>{moreBtnDlgData.suggest = (item.os_content)}">{{item.os_content}}</el-dropdown-item>
                            <el-dropdown-item @click="()=>{moreBtnDlgData.suggest = '同意'}">同意</el-dropdown-item>
                            <el-dropdown-item @click="()=>{moreBtnDlgData.suggest = '不同意'}">不同意</el-dropdown-item>
                        </el-dropdown-menu>
                        </template>
                    </el-dropdown>
              </div>
            </div>
            <div class="dlg_item_c">
              <el-input
                v-model="moreBtnDlgData.suggest"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5}"
                placeholder="请输入内容"
                @blur="opIptBlur"
              ></el-input>
            </div>
          </div>
          <div class="dlg_item">
            <div class="dlg_item_title">
              <p>相关附件</p>
            </div>
            <div class="dlg_item_c">
                 <component :is="'attachmentFld'" v-model="moreBtnDlgData.attach" :layoutMode="'UPDOWN'" :scene="'PCADD'" :fldObj="fldObj" auth="EDIT" />
            </div>
          </div>
          <div style="display: flex;align-items: center;" v-if="moreBtnDlgData.type == 2">
            <el-checkbox v-model="moreBtnDlgData.signType" :true-label="'BACK'" :false-label="'FRONT'"  label="后加签" size="large" />
            <el-tooltip
                class="box-item"
                effect="dark"
                content="不需要返回原审批人:加签人处理完任务后，流程直接进入下一节点;"
                placement="top-start"
            >
                <i class="iconfont icon-xiaoxitishi" style="margin-left:12px;font-size:14px;color:#909099;"></i>
            </el-tooltip>
          </div>
        </div>
        <template #footer>
          <div class="dialog_footer">
            <el-button @click="moreBtnDlgVs=false">取消</el-button>
            <!-- <el-button type="primary" plain @click="saveTaskExtraData" style="color:var(--mainColor);background:#e5f3fa">暂存</el-button> -->
            <el-button type="primary" @click="checkOpFunc">确认</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!-- 人员选择器 -->
    <empSelector
      v-model:dlgVisiable="empShow"
      :isMulti="moreBtnDlgData.type == 2"
      v-model="showEmpArr"
      @selectUser="selectUser"
    ></empSelector>
  </div>
</template>

<script>
import flowPath from "qs3_pc_tblcommon/src/flowDtl/flow/flowPath/flowPath.vue"
import {calFilter,setSessions} from 'qs3_pc_common/src/workTbl/calFilter'
import { empSelector,sign } from 'qs3_pc_common'
import { ref, defineAsyncComponent } from "vue";
import team from "qs3_pc_tblcommon/src/common/team.vue"
import rowDataLog from "qs3_pc_tblcommon/src/workTbl/dataLog/rowDataLog.vue"
import formFlds from "qs3_formfld";
import fileDtl from "../../bizFlow/common/flowFileDtl.vue"
const attachmentFld = defineAsyncComponent(() => import('qs3_formfld/src/field/base/attachment/form.vue'));
export default {
  components: {
    ...formFlds.components,
    empSelector,
    flowPath,
    team,
    rowDataLog,
    sign,
    fileDtl,
    attachmentFld,
  },
  props: {
    dlgVisiable: Boolean,
    fiId: {
      type: String,
      default: function () {
        return null;
      },
    },
    taskId: {
      type: String,
      default: function () {
        return null;
      },
    },
    ccId: {
      type: String,
      default: function () {
        return null;
      },
    },
    exeId: {
      type: String,
      default: function () {
        return null;
      },
    },
    // RUNTASK-运行时任务详情 HITASK-历史任务详情 FLOW-流程详情
    scene: {
      type: String,
      default: function () {
        return "RUNTASK";
      },
    },
    isFinsh: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    hasModal: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    curIndex: {
      type: Number,
      default: function () {
        return null;
      },
    },
    curTotal: {
      type: Number,
      default: function () {
        return 1;
      },
    },
    dtlTitle: {
      type: String,
      default: function () {
        return "流程审批";
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      showSlotFlag: true,
      canSubMit:true,
      layoutMode: "UPDOWN",
      activeName: "first",
      urgings: [],
      canDoSet:{
        reCallCanDo:true,
        reScindCanDo:true
      },
      taskCenterTaskId: false,
      moreBtns: {
        'transfer': {
          name: '转交',
          type: 1,
          icon: 'iconfont icon-zhuanjiao1'
        },
        'add': {
          name: '加签',
          type: 2,
          icon: 'iconfont icon-jiaqian2'
        },
      },
      retrunNodes: [],
      succAndRefDlgVs: false,
      signFile: '',
      succAndRefDlgData: {
        title: '',
        suggest: '',
        fnId: null,
        iptIndex: null,
        sign: null,
      },
      submitType:'',
      fldsList:{},
      offSugList: [],
      suggestBoxVs: false,
      moreBtnDlgVs: false,
      moreBtnDlgTitle: '转交',
      moreEmpObj: {
        1: {
          title: '转交处理人',
          name: '添加转交人',
          emps: []
        },
        2: {
          title: '加签处理人',
          name: '添加加签人',
          emps: []
        }
      },
      moreBtnDlgData: {
        type: null,
        suggest: '',
        iptIndex: null
      },
      showEmpArr: [],
      empShow: false,
      auditConfig: null,
      formAuth: null,
      wtId: '',
      taskType: '',
      curScene: '',
      curFiId: '',
      curTaskId: '',
      isRefreshPath: false,
      opSceneObj: {},
      examinOpObj: null,
      flowBaseSet: null,
      isloading: false,
      hasSetAudit:false,
      dtlRowData:{},
      bizFlowNodeId:'',
      flowVerDtl:{},
      bizFlowNodeDtl:{},
      displayRule:null,
      userAuth:{},
      relateTblFlds:{},
      task:null,
      subTaskTab: 'children',
      fldObj: {
        id: "task_attach",
        name: "附件",
        title: "附件",
        type: "ATTACHMENT",
        icon: "icon-fujian",
        dataType: 'JSON',
        isArray: true,
        height: 1,
        flieType: 'FATTACHMENT',
        attr: {
          seq: 'after',
          limitDownload: false,
          supportKpage: false,
          limitNumber: null,
          limitSize: null,
          attr: null,
          validate: {
            notEmpty: false,
            allowDuplicate: false,
          },
          hint: '',
          reMarkType: null,
          remark: '',
        }
      },
      nextSetFlag:false,
      isAddSign:false,
    };
  },
  setup() {
    const flds = ref({});
    const editRowData = ref({});
    const layout = ref({
      lineIds: [],
      lines: {},
    });
    const deepLayout =ref({
        lineIds:[],
        lines:{}
    })
    return {
      flds,
      layout,
      deepLayout,
      editRowData,
    };
  },
  watch: {

    dlgVisiable: {
      handler(newVal) {
        this.dialogVisible = newVal;
        if(newVal) {
          this.curFiId = this.fiId
          this.curTaskId = this.taskId
          this.curScene = this.scene
          this.editRowData = {}
          this.dtlRowData = {}
          this.layout = {
            lineIds:[],
            lines:{}
          }
          this.invokerFlowDtl()
          this.queryRelateBpaInfo()
        }
      },
      immediate: true,
      deep: true,
    },
    curIndex: {
      handler(newVal) {
        if(newVal!=null&&this.dialogVisible) {
          this.curFiId = this.fiId
          this.curTaskId = this.taskId
          this.curScene = this.scene
          this.editRowData = {}
          this.dtlRowData = {}
          this.layout = {
            lineIds:[],
            lines:{}
          }
          this.invokerFlowDtl()
          this.queryRelateBpaInfo()
        }
      },
      immediate: false,
      deep: true,
    },
    dtlRowData: {
        handler(newVal) {
            if(newVal){
                this.initLayout()
            }
        },
        immediate: true,
        deep: true,
    },
  },
  mounted() {
    this.queryMyOs()
    this.curScene = this.scene
    this.nextSetFlag = localStorage.getItem('qs_nextSetFlag') == 'open'?true:false
  },
  methods: {
    changeNextFlag(){
        localStorage.setItem('qs_nextSetFlag',this.nextSetFlag?'open':'close')
    },
    queryRelateBpaInfo(){
        if(this.scene != 'CC' && this.curTaskId){
            this.$http.post(this.$api.flow.queryRelateBpaInfo,{
                taskId: this.curTaskId,
            }).then(res => {
                if(res.payload && res.payload.bsg_node_id){
                    this.bizFlowNodeId = res.payload.bsg_node_id
                    this.bizFlowNodeDtl = JSON.parse(res.payload.bsg_node_config) || {}
                    this.flowVerDtl = {'bfv_bfId':res.payload['bsg_node_bfId'],'bfv_id':res.payload['bsg_node_bvId']}
                }
                else{
                    this.bizFlowNodeId = null
                    this.bizFlowNodeDtl = {}
                }
            })
        }
    },
    queryUrgeLogList() {
      if(this.opSceneObj[this.curFiId]) {
        this.curScene = this.opSceneObj[this.curFiId]
      }
      if(!this.curFiId){
        return
      }
      this.$http.post(this.$api.bpm.workbentch.dtl.queryUrgeLogList,{
        fi_id: this.curFiId,
      }).then(res => {
        this.urgings = res.payload
      })
    },
    queryFormDtlStruct(wtId,tlId,data){
        if(wtId){
            this.$http.post(this.$api.worktbl.queryFormDtlStruct, {
                wt_id: wtId,
                tl_id: tlId || null,
            }).then((res)=>{
                if(res.payload.wt_flds){
                    this.flds = JSON.parse(res.payload.wt_flds)
                    this.deepLayout = JSON.parse(res.payload.wt_formLayout)
                    this.layoutMode = res.payload.wt_layoutStyle
                    this.toInitRelateList()
                    this.initRunDtl(data)
                }
            })
        }
    },
    queryFormDtlAllStruct(wtId){
        if(wtId){
            this.$http.post(this.$api.worktbl.queryFormDtlStruct, {
                wt_id: wtId,
            }).then((res)=>{
                if(res.payload.wt_flds){
                    let flds = JSON.parse(res.payload.wt_flds)
                    this.fldsList = {}
                    for(let item of this.auditConfig.dealFldsSet){
                        if(this.flds[item.fldId] || flds[item.fldId]){
                            this.fldsList[item.fldId] = JSON.parse(JSON.stringify(this.flds[item.fldId] || flds[item.fldId]))
                            if(!this.fldsList[item.fldId].attr.validate){
                                this.fldsList[item.fldId].attr.validate = {} 
                            }
                            this.fldsList[item.fldId].attr.validate.notEmpty = (item.validateType == 'REQUIRED')
                        }
                    }
                }
            })
        }
    },
    invokerFlowDtl() {
      if(this.opSceneObj[this.curFiId]) {
        this.curScene = this.opSceneObj[this.curFiId]
      }
      this.isloading = true
      this.hasSetAudit = true
      
    this.queryTaskById().then(()=>{
        if(!this.curFiId){
            return
        }
        this.$http.post(this.$api.bpm.workbentch.dtl.invokerFlowDtl,{
          fiId: this.curFiId,
          taskId: this.curTaskId,
          ccId: this.ccId,
          scene: this.curScene
        }).then(res => {
          this.editRowData = {...(res.payload.formData || {}),...this.editRowData}
  
          this.dtlRowData = JSON.parse(JSON.stringify(res.payload.formData)) || {}
          this.canDoSet = res.payload.canDoSet || {}
          setSessions(this).then(()=>{
              this.$http.post(this.$api.worktbl.queryBizRule,{
                  wt_id: res.payload.wtId
              }).then((resRule)=>{
                  if(resRule.payload){
                      this.displayRule = JSON.parse(resRule.payload) || []
                  }
                  // 赋值taskCenterTaskId
                  this.taskCenterTaskId = res.payload.taskCenterTaskId || null;
                  if (this.taskCenterTaskId) {
                    this.fetchTaskCenterTaskDetail(this.taskCenterTaskId);
                      this.activeName = "task"; // 有任务时切换到任务tab
                  } else {
                    this.activeName = "first"; // 没有任务时切换到流转路径tab
                    this.task = null;
                  }
                  if(this.editRowData['_layoutId']){
                      this.queryFormDtlStruct(res.payload.wtId,this.editRowData['_layoutId'],res)
                      this.isloading = false
                      return
                  }
                  this.flds = JSON.parse(res.payload.dataStruct.wt_flds);
                //   this.layout = JSON.parse(res.payload.dataStruct.wt_formLayout);
                  this.deepLayout = JSON.parse(res.payload.dataStruct.wt_formLayout)
                  this.layoutMode = res.payload.dataStruct.wt_layoutStyle;
                  this.toInitRelateList()
                  this.initRunDtl(res)
  
                  this.isloading = false
                  
              })
          })
          
        }).catch(() => {
          this.isloading = false
        })
    })
    },
    initRunDtl(res){
        this.queryUrgeLogList()
        this.flowBaseSet = res.payload.flowBaseSet ? JSON.parse(res.payload.flowBaseSet) : null
        this.auditConfig = res.payload.auditConfig || {}
        this.hasSetAudit = false
        if(this.auditConfig && this.auditConfig.dealFldsSet){
            this.queryFormDtlAllStruct(res.payload.wtId)
        }
        this.wtId = res.payload.wtId
        this.taskType = res.payload.taskType
        if(this.taskType==10&&this.curScene!='HITASK') {
          this.queryFlowBackNodes()
        }
        this.formAuth = {}
        this.examinOpObj = null
        if(this.auditConfig&&this.auditConfig.examineAction) {
          this.examinOpObj = {}
          for(let item of this.auditConfig.examineAction) {
            this.examinOpObj[item] = true
          }
        }
        if(this.examinOpObj) {
          if(!this.examinOpObj['transfer']) {
            delete this.moreBtns['transfer']
          }
          if(!this.examinOpObj['add']) {
            delete this.moreBtns['add']
          }
        }
        this.queryCurUserRowAuth()
        this.initLayout()
    },
    computeDisplayRule(){
        let authObj = {}
        if(!this.displayRule){
            return {}
        }
        for(let item of this.displayRule){
            if(!item.isOpen){
                continue
            }
            for(let zitem of item.actions){
                if(calFilter(item.filter,this.dtlRowData,this)){
                    authObj[zitem.fldId] = zitem.action
                }
            }
        }
        return authObj
    },
    computeFldAuth(fldId){
        let displayRule = this.computeDisplayRule()
        let rules = []
        rules.push(displayRule[fldId])
        if(this.flds[fldId]){
            if(this.flds[fldId].attr){
                if(this.flds[fldId].attr.attr){
                    if(this.flds[fldId].attr.attr == 'readOnly'){
                        rules.push('READONLY')
                    }
                    if(this.flds[fldId].attr.attr == 'hideAlways'){
                        rules.push('HIDDEN')
                    }   
                }
            }
        }
        if(this.auditConfig&&this.auditConfig.formAuth) {
          for(let key in this.auditConfig.formAuth) {
            rules.push(this.auditConfig.formAuth[key].auth)
          }
        } 
        if(this.auditConfig.hideFldsSet){
            for(let item of this.auditConfig.hideFldsSet){
                if(item == fldId){
                    rules.push('HIDDEN')
                }
            }
        }
        if(this.curScene !='RUNTASK'){
            return rules.includes('HIDDEN') ? 'HIDDEN' : (rules.includes('READONLY')?'READONLY':'EDIT')
        }
        if(rules.includes('HIDDEN')){
            return 'HIDDEN'
        }
        if(rules.includes('READONLY')){
            return 'READONLY'
        }
        return 'EDIT'
    },
    initLayout(){
      let layout = JSON.parse(JSON.stringify(this.deepLayout)) 
      for(let key in layout.lines){
        if(layout.lines[key].type == "FENCE"){
          for(let cindex in layout.lines[key].set.cols){
            layout.lines[key].set.cols[cindex].rows = 
            layout.lines[key].set.cols[cindex].rows.filter((rowItem)=>{
              return (this.computeFldAuth(rowItem.fldId) != 'HIDDEN') && this.flds[rowItem.fldId]
            })
          }
          let colLength = layout.lines[key].set.cols.length
          layout.lines[key].set.cols = 
          layout.lines[key].set.cols.filter((citem)=>{return citem.rows.length>0})
          if(colLength != layout.lines[key].set.cols.length){
            for(let colItem of layout.lines[key].set.cols){
              colItem.width = '1/'+layout.lines[key].set.cols.length
            }
          }
        }
      }
      layout.lineIds = (layout.lineIds || []).filter((key)=>{
        if(layout.lines[key].type == 'FENCE'){
          return layout.lines[key].set.cols.length>0
        }else{
          return true
        }
      })
        this.layout.lineIds = layout.lineIds
        this.layout.lines = layout.lines
    },
    queryFlowBackNodes() {
      this.$http.post(this.$api.bpm.workbentch.dtl.queryFlowBackNodes,{
        exeId: this.exeId,
        fi_id: this.curFiId,
      }).then(res => {
        if(res.payload) {
          this.retrunNodes = res.payload
        }
      })
    },
    indexChange(num) {
      this.$emit('indexChange',num)
    },
    queryMyOs() {
      this.$http.post(this.$api.bpm.workbentch.oftenSuggest.queryMyOs,{}).then(res => {
        this.offSugList = res.payload
      })
    },
    showdealDlg() {
        if(this.auditConfig.isOpenSuggest || (this.auditConfig.dealFldsSet && this.auditConfig.dealFldsSet.length > 0)){
            this.submitType = 'dealNode'
            this.succAndRefDlgVs = true
            this.succAndRefDlgData.title = '办理当前节点'
        }
        else{
            this.$confirm('是否办理？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                nodeType: 'warning'
            }).then(() => {
                this.deal()
            })
        }
    },
    checkToShowSuccDlg(){
        if(this.auditConfig && this.auditConfig.isOpenSuggest){
            this.showSuccDlg()
        }
        else{
            if(this.hasSetAudit){
                setTimeout(()=>{
                    this.checkToShowSuccDlg()
                },80)
            }
            else{
                this.showSuccDlg()
            }
        }
    },
    checkToShowRefDlg(){
        if(this.auditConfig && this.auditConfig.isOpenSuggest){
            this.showRefDlg()
        }
        else{
            if(this.hasSetAudit){
                setTimeout(()=>{
                    this.checkToShowRefDlg()
                },80)
            }
            else{
                this.showRefDlg()
            }
        }
    },
    checkToShowdealDlg(){
        if(this.auditConfig){
            this.showdealDlg()
        }
        else{
            if(this.hasSetAudit){
                setTimeout(()=>{
                    this.checkToShowdealDlg()
                },80)
            }
            else{
                this.showdealDlg()
            }
        }
    },
    showSuccDlg() {
        this.succAndRefDlgData.title = '同意当前流程审批任务'
        if(this.auditConfig.isOpenSuggest !== false || (this.auditConfig.dealFldsSet && this.auditConfig.dealFldsSet.length > 0)){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else if((this.succAndRefDlgData.title=='拒绝当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.refuse) || (this.succAndRefDlgData.title=='同意当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.pass)){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else{
            this.$confirm('是否通过当前审批？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                nodeType: 'warning'
            }).then(() => {
                this.passAndRefuset()
            })
        }
      
    },
    showRefDlg() {
      this.succAndRefDlgData.title = '拒绝当前流程审批任务'
      if(this.auditConfig.isOpenSuggest !== false || (this.auditConfig.dealFldsSet && this.auditConfig.dealFldsSet.length > 0)){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else if((this.succAndRefDlgData.title=='拒绝当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.refuse) || (this.succAndRefDlgData.title=='同意当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.pass)){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else{
            this.$confirm('是否拒绝当前审批？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                nodeType: 'warning'
            }).then(() => {
                this.passAndRefuset()
            })
        }
    },
    showRefAddDlg() {
      this.succAndRefDlgData.title = '拒绝当前加签审批任务'
      if(this.auditConfig.isOpenSuggest !== false || (this.auditConfig.dealFldsSet && this.auditConfig.dealFldsSet.length > 0)){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else if((this.succAndRefDlgData.title=='拒绝当前加签审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.refuse) || (this.succAndRefDlgData.title=='同意当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.pass)){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else{
            this.$confirm('拒绝当前加签审批任务？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                nodeType: 'warning'
            }).then(() => {
                this.passAndRefuset()
            })
        }
    },
    backPreNode() {
      this.succAndRefDlgData.title = '退回上一节点'
      if(this.auditConfig.isOpenSuggest !== false){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else{
            this.$confirm('是否退回到发起人？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                nodeType: 'warning'
            }).then(() => {
                this.passAndRefuset()
            })
        }
      if(this.$refs.returnRef){
        this.$refs.returnRef.hide()
      }
    },
    backSponsor() {
      this.succAndRefDlgData.title = '退回到发起人'
      if(this.auditConfig.isOpenSuggest !== false){
            this.submitType = 'spNode'
            this.succAndRefDlgVs = true
        }
        else{
            this.$confirm('是否退回到发起人？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                nodeType: 'warning'
            }).then(() => {
                this.passAndRefuset()
            })
        }
      if(this.$refs.returnRef){
        this.$refs.returnRef.hide()
      }
    },
    backNode() {
      this.submitType = 'spNode'
      this.succAndRefDlgData.fnId = null
      this.succAndRefDlgVs = true
      this.succAndRefDlgData.title = '退回指定节点'
      if(this.$refs.returnRef){
        this.$refs.returnRef.hide()
      }
    },
    suggestIptBlur(e) {
      this.succAndRefDlgData.iptIndex = e.srcElement.selectionStart;
    },
    selectOffSug(content) {
      let index = this.succAndRefDlgData.iptIndex
      let str = this.succAndRefDlgData.suggest
      if(index==null) {
        return this.succAndRefDlgData.suggest = content
      }
      this.succAndRefDlgData.suggest = str.slice(0, index) + content + str.slice(index);
    },
    opIptBlur(e) {
      this.moreBtnDlgData.iptIndex = e.srcElement.selectionStart;
    },
    selectOpSug(content) {
      let index = this.moreBtnDlgData.iptIndex
      let str = this.moreBtnDlgData.suggest
      if(index==null) {
        return this.moreBtnDlgData.suggest = content
      }
      this.moreBtnDlgData.suggest = str.slice(0, index) + content + str.slice(index);
    },
    passAndRefuset() {
        if(!this.canSubMit){
            return
        }
        this.canSubMit = false
        if(this.submitType == 'dealNode'){
            this.deal()
            return
        }
      let {title,suggest,fnId} = this.succAndRefDlgData
      if(this.succAndRefDlgData.title != '退回到发起人' && this.succAndRefDlgData.title != '退回指定节点' && this.auditConfig.dealFldsSet){
        for(let item of this.auditConfig.dealFldsSet){
            if(item.validateType == 'REQUIRED' && item.fldId && this.fldsList[item.fldId] && (this.editRowData[item.fldId] === null || this.editRowData[item.fldId] === '' || this.editRowData[item.fldId] === undefined)){
                this.canSubMit = true
                return this.$message({
                    type: 'error',
                    message: '请填写必填项'
                });
            }
            let keyList = ['RELATETBL','CHILDTBL']
            if(item.fldId && this.fldsList[item.fldId] && keyList.includes(this.fldsList[item.fldId].type)){
                if(this.fldsList[item.fldId].type == 'CHILDTBL'){
                    let requireList = (this.fldsList[item.fldId].childFlds || []).filter((xitem)=>{
                        return xitem.attr.validate && xitem.attr.validate.notEmpty
                    })
                    for(let row of this.editRowData[item.fldId] || []){
                        for(let fldItem of requireList){
                            if(row[fldItem.id] === null || row[fldItem.id] === '' || row[fldItem.id] === undefined){
                                this.canSubMit = true
                                return this.$message({
                                    type: 'error',
                                    message: '请填写必填项'
                                });
                            }
                        }
                    }
                }
                if(this.fldsList[item.fldId].type == 'RELATETBL'){
                    let displayFlds = this.fldsList[item.fldId].attr.relateTblSet.displayFlds
                    let requireList = Object.values(this.relateTblFlds[item.fldId] || {}).filter((xitem)=>{
                        return xitem.attr.validate && xitem.attr.validate.notEmpty && displayFlds.includes(xitem.id)
                    })
                    for(let row of this.editRowData[item.fldId] || []){
                        for(let fldItem of requireList){
                            if(row[fldItem.id] === null || row[fldItem.id] === '' || row[fldItem.id] === undefined){
                                this.canSubMit = true
                                return this.$message({
                                    type: 'error',
                                    message: '请填写必填项'
                                });
                            }
                        }
                    }
                }
            }
        }
      }
      if((this.auditConfig.isOpenSuggest !== false || this.auditConfig.isOpenSuggest && (this.succAndRefDlgData.title == '退回到发起人' || this.succAndRefDlgData.title == '退回指定节点')) && suggest=='' && this.auditConfig.isRequireSuggest !== false) {
        this.canSubMit = true
        return this.$message({
          type: 'error',
          message: '请输入意见'
        });
      }
      let parm = {
        fiId: this.fiId,
        taskId: this.curTaskId,
        formData: this.editRowData,
        suggest : this.auditConfig.isOpenSuggest !== false  ? suggest : null,
        attach:this.succAndRefDlgData.attach
      }
      let _api = this.$api.bpm.workbentch.dtl.pass
      if (title == '拒绝当前流程审批任务') {
        _api = this.$api.bpm.workbentch.dtl.refuse
      } else if (title == '退回到发起人') {
        _api = this.$api.bpm.workbentch.dtl.backToCreator
      }else if (title == '退回指定节点') {
        _api = this.$api.bpm.workbentch.dtl.backTo
        parm.fnId = fnId
        parm.scene = 'SPECIFYONE'
      }else if (title == '退回上一节点') {
        _api = this.$api.bpm.workbentch.dtl.backTo
        parm.fnId = null
        parm.scene = 'PREVIOUSONE'
      }else if (title == '拒绝当前加签审批任务') {
        _api = this.$api.bpm.workbentch.dtl.rejectSign
      }
      if((title=='拒绝当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.refuse) || (title=='同意当前流程审批任务'&&this.auditConfig&&this.auditConfig.sign&&this.auditConfig.sign.pass)) {
        if(!this.signFile) {
            this.canSubMit = true
          return this.$message({
            type: 'warning',
            message: '请签名'
          });
        }
        const chunkSize = 1024 * 1024 * 5
        if(this.signFile.size >= chunkSize){
            this.$uploadOp.getRefDom().bigUpload(this.signFile,0).then((fileId)=>{
                this.$message({
                    type: "success",
                    message: '文件上传中，完成后即可预览',
                });
                let file_id = fileId
                this.succAndRefDlgData.sign = file_id
                parm.sign = this.succAndRefDlgData.sign
                this.commitFunc(_api,parm,title)
            })
        }
        else{
            let formObj = new FormData();
            formObj.append("file",this.signFile);
            formObj.append("scene",'img');
            formObj.append("isDownload",'false');
            this.$http.post(this.$api.worktbl.uploadPrivateFile,formObj).then(res => {
                let file_id = res.payload.file_id
                this.succAndRefDlgData.sign = file_id
                parm.sign = this.succAndRefDlgData.sign
                this.commitFunc(_api,parm,title)
            })
        }

      } else {
        
        this.commitFunc(_api,parm,title)
      }
    },
    commitFunc(api,parm,title) {
        setTimeout(()=>{
            this.$http.post(api,parm).then(() => {
                this.hTaskFunc()
                this.succAndRefDlgVs = false
                this.$message({
                type: 'success',
                message: title + '成功'
                });
                this.canSubMit = true
                this.signFile = null
                this.$nextTick(()=>{
                    this.$emit("handleEndFunc");
                })
                if(this.nextSetFlag){
                    this.$emit('toSetOpNext')
                    this.closeDaliogFunc()
                }
            }).catch(()=>{
                this.canSubMit = true
                this.signFile = null
            })
        },800)
    },
    deal() {
        let dealFlds = []
        if(this.auditConfig.dealFldsSet){
            for(let item of this.auditConfig.dealFldsSet){
                if(this.fldsList[item.fldId]){
                    dealFlds.push(item.fldId)
                }
                if(item.validateType == 'REQUIRED' && item.fldId && this.fldsList[item.fldId] && (this.editRowData[item.fldId] === null || this.editRowData[item.fldId] === '' || this.editRowData[item.fldId] === undefined)){
                    this.canSubMit = true
                    return this.$message({
                        type: 'error',
                        message: '请填写必填项'
                    });
                }
                let keyList = ['RELATETBL','CHILDTBL']
                if(item.fldId && this.fldsList[item.fldId] && keyList.includes(this.fldsList[item.fldId].type)){
                    if(this.fldsList[item.fldId].type == 'CHILDTBL'){
                        let requireList = (this.fldsList[item.fldId].childFlds || []).filter((xitem)=>{
                            return xitem.attr.validate && xitem.attr.validate.notEmpty
                        })
                        if(typeof this.editRowData[item.fldId] == 'string'){
                            this.editRowData[item.fldId] = JSON.parse(this.editRowData[item.fldId])
                        }
                        for(let row of this.editRowData[item.fldId] || []){
                            for(let fldItem of requireList){
                                if(row[fldItem.id] === null || row[fldItem.id] === '' || row[fldItem.id] === undefined){
                                    this.canSubMit = true
                                    return this.$message({
                                        type: 'error',
                                        message: '请填写必填项'
                                    });
                                }
                            }
                        }
                    }
                    if(this.fldsList[item.fldId].type == 'RELATETBL'){
                        let displayFlds = this.fldsList[item.fldId].attr.relateTblSet.displayFlds
                        let requireList = Object.values(this.relateTblFlds[item.fldId] || {}).filter((xitem)=>{
                            return xitem.attr.validate && xitem.attr.validate.notEmpty && displayFlds.includes(xitem.id)
                        })
                        for(let row of this.editRowData[item.fldId] || []){
                            for(let fldItem of requireList){
                                if(row[fldItem.id] === null || row[fldItem.id] === '' || row[fldItem.id] === undefined){
                                    this.canSubMit = true
                                    return this.$message({
                                        type: 'error',
                                        message: '请填写必填项'
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }
        let {suggest} = this.succAndRefDlgData
        if(this.auditConfig.isOpenSuggest&& suggest=='') {
            this.canSubMit = true
            return this.$message({
            type: 'error',
            message: '请输入意见'
            });
        }
        let _api = this.$api.bpm.workbentch.dtl.deal
        if(this.taskType==50) {
          _api = this.$api.bpm.workbentch.dtl.createdeal
        }
        let copyData = this.taskType==50 ?this.dtlRowData : this.editRowData
        let backDataObj = this.toCheckIsEmpty(copyData,this.taskType==50,dealFlds) || {}
        let rowData = backDataObj.rowData
        if(backDataObj.flag && this.taskType==50){
            return
        }
        let parm = {
          fiId: this.fiId,
          taskId: this.curTaskId,
          formData: rowData,
          suggest : this.auditConfig.isOpenSuggest ? suggest : null
        }
        this.$http.post(_api,parm).then(() => {
            if(this.taskType==50) {
                this.hubFunc()
            } else {
                this.hTaskFunc()
            }
            this.$message({
                type: 'success',
                message: '办理成功'
            });
            this.succAndRefDlgVs = false
            this.canSubMit = true
            this.$nextTick(()=>{
                this.$emit("handleEndFunc");
            })
            }).catch(() => {
                this.canSubMit = true
        })
    },
    selectOp(type) {
      if(this.$refs.popRef){
        this.$refs.popRef.hide()
      }
      if(type==1 ||type==2) {
        this.moreBtnDlgData.type = type
        this.moreBtnDlgVs = true
        let obj = {
            1:'transfer',
            2:'add',
        }
        this.moreBtnDlgTitle = this.moreBtns[obj[type]].name
      }
    },
    rescind() {
      this.$confirm('是否撤销该流程？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        nodeType: 'warning'
      }).then(() => {
        let _api = this.$api.bpm.workbentch.dtl.rescind
        let parm = {
          fiId: this.fiId
        }
        this.$http.post(_api,parm).then(() => {
          this.closeDaliogFunc()
          this.$message({
            type: 'success',
            message: '撤销成功'
          });
        })
      }).catch(() => {
      })
    },
    revoke() {
      this.$confirm('是否撤回？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        nodeType: 'warning'
      }).then(() => {
        let _api = this.$api.bpm.workbentch.dtl.revoke
        let parm = {
          fiId: this.fiId,
          taskId: this.curTaskId,
          formData: this.editRowData,
        }
        this.$http.post(_api,parm).then((res) => {
          this.curTaskId = res.payload.other.revokeTaskId
          this.revokeSubFunc()
          this.$message({
            type: 'success',
            message: '撤回成功'
          });
        })
      }).catch(() => {
      })
    },
    urge() {
      this.$confirm('是否催办？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        nodeType: 'warning'
      }).then(() => {
        let _api = this.$api.bpm.workbentch.dtl.urge
        let parm = {
          fiId: this.fiId,
        }
        this.$http.post(_api,parm).then(() => {
          this.queryUrgeLogList()
          this.$message({
            type: 'success',
            message: '催办成功'
          });
        })
      }).catch(() => {
      })
    },
    revokedeal() {
      this.$confirm('是否提交？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        nodeType: 'warning'
      }).then(() => {
        let backDataObj = this.toCheckIsEmpty(this.dtlRowData) || {}
        let rowData = backDataObj.rowData
        if(backDataObj.flag){
            return
        }
        let _api = this.$api.bpm.workbentch.dtl.revokedeal
        let parm = {
          fiId: this.fiId,
          taskId: this.curTaskId,
          formData: rowData,
        }
        this.$http.post(_api,parm).then(() => {
          this.hubFunc()
          this.$message({
            type: 'success',
            message: '提交成功'
          });
        })
      }).catch(() => {
      })
    },
    toCheckIsEmpty(copyData,showTip = true,dealFlds=[]){
        let rowData = {}
        for(let key in copyData){
            if(key.startsWith('_') || this.flds[key]){
                rowData[key] = copyData[key]
            }
        }
        let hasEmptyFlag = false
        let hasEmptyObj = {}
        let titleObj = {}
        for(let ckey in this.flds){
            let ref = 'tblFLds_' + ckey
            let keyList = ['RELATETBL','CHILDTBL']
            let dom = document.getElementById(ref)
            if(!dom && !dealFlds.includes(ckey)){
                delete rowData[ckey]
            }
            if(this.flds[ckey].attr.validate && this.flds[ckey].attr.validate.notEmpty){
                if(dom && (rowData[ckey] === null || rowData[ckey] === undefined || rowData[ckey] === '')){
                    hasEmptyFlag = true
                    hasEmptyObj[ckey] = true
                    titleObj[ckey] = this.flds[ckey].title
                    rowData[ckey] = null
                }
                else if(dom && (keyList.includes(this.flds[ckey].type) && rowData[ckey] && rowData[ckey].length == 0)){
                    hasEmptyFlag = true
                    hasEmptyObj[ckey] = true
                    titleObj[ckey] = this.flds[ckey].title
                    rowData[ckey] = null
                }
            }
            if(dom && ckey && this.flds[ckey] && keyList.includes(this.flds[ckey].type)){
                if(this.flds[ckey].type == 'CHILDTBL'){
                    let requireList = (this.flds[ckey].childFlds || []).filter((xitem)=>{
                        return xitem.attr.validate && xitem.attr.validate.notEmpty
                    })
                    if(typeof rowData[ckey] == 'string'){
                        rowData[ckey] = JSON.parse(rowData[ckey])
                    }
                    for(let row of rowData[ckey] || []){
                        for(let fldItem of requireList){
                            if(row[fldItem.id] === null || row[fldItem.id] === '' || row[fldItem.id] === undefined){
                                hasEmptyFlag = true
                                hasEmptyObj[ckey] = true
                                titleObj[ckey] = this.flds[ckey].title + '-' +fldItem.title
                            }
                        }
                    }
                }
                if(this.flds[ckey].type == 'RELATETBL'){
                    let displayFlds = this.flds[ckey].attr.relateTblSet.displayFlds
                    let requireList = Object.values(this.relateTblFlds[ckey] || {}).filter((xitem)=>{
                        return xitem.attr.validate && xitem.attr.validate.notEmpty && displayFlds.includes(xitem.id)
                    })
                    for(let row of rowData[ckey] || []){
                        for(let fldItem of requireList){
                            if(row[fldItem.id] === null || row[fldItem.id] === '' || row[fldItem.id] === undefined){
                                hasEmptyFlag = true
                                hasEmptyObj[ckey] = true
                                titleObj[ckey] = this.flds[ckey].title + '-' +fldItem.title
                            }
                        }
                    }
                }
            }
        }
        if(hasEmptyFlag && showTip){
            let msg = '字段：'
            for(let key in hasEmptyObj){
                msg += `【${titleObj[key] || this.flds[key].title}】`
            }
            msg += ' 为必填字段！'
            this.$message({
                type: 'error',
                message: msg,
                }
            )
            return {rowData:rowData,flag:true}
        }
        return  {rowData:rowData,flag:false}
    },
    // 撤回办理提交、退回办理提交切换流程场景
    hubFunc() {
      this.opSceneObj[this.curFiId] = 'FLOW'
      this.curScene = 'FLOW'
      this.curTaskId = null
      this.invokerFlowDtl()
      this.isRefreshPath = true
    //   this.dialogVisible = false;
    },
    // 完成其他操作，切换成历史任务场景
    hTaskFunc() {
      this.opSceneObj[this.curFiId] = 'HITASK'
      this.curScene = 'HITASK'
      this.invokerFlowDtl()
      this.isRefreshPath = true
    //   this.dialogVisible = false;
    },
    // 撤回切换办理提交
    revokeSubFunc() {
      this.opSceneObj[this.curFiId] = 'HITASK'
      this.curScene = 'RUNTASK'
      this.invokerFlowDtl()
      this.isRefreshPath = true
    //   this.dialogVisible = false;
    },
    checkOpFunc() {
      let emps = this.moreEmpObj[this.moreBtnDlgData.type].emps
      let {type,suggest} = this.moreBtnDlgData
      if(!emps[0]){
        this.$message({
          type: 'error',
          message: '请选择处理人'
        });
        return 
      }
      if(type == 1 && !suggest){
        this.$message({
          type: 'error',
          message: '请填写处理意见'
        });
        return 
      }
      let _api = this.$api.bpm.workbentch.dtl.transfer
      let parm = {
        fiId: this.fiId,
        taskId: this.curTaskId,
        formData: this.editRowData,
        suggest,
        emp: {
          emp_id: emps[0].emp_id,
          emp_name: emps[0].emp_name
        },
        emps:emps,
        attach:this.moreBtnDlgData.attach
      }

      if(type==2) {
        _api = this.$api.bpm.workbentch.dtl.add
        parm['type'] = this.moreBtnDlgData.signType || 'FRONT'
      }
      this.$http.post(_api,parm).then(() => {
        this.canSubMit = true
        this.hTaskFunc()
        this.moreBtnDlgVs = false
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.moreEmpObj[this.moreBtnDlgData.type].emps = []
      })
    },
    openEmp() {
      this.showEmpArr = this.moreEmpObj[this.moreBtnDlgData.type].emps
      this.empShow = true
    },
    selectUser(val) {
      this.moreEmpObj[this.moreBtnDlgData.type].emps = val.emps
    },
    delEmp(index) {
      this.moreEmpObj[this.moreBtnDlgData.type].emps.splice(index,1)
    },
    closeDaliogFunc() {
      this.dialogVisible = false;
      this.opSceneObj = {}
      this.curScene = ''
      this.curFiId = ''
      this.curTaskId = ''
      this.isRefreshPath = false
      this.$emit("update:dlgVisiable", this.dialogVisible);
      this.$emit("changeValue");
    },
    computedWidth(colItem, length) {
      if (length > 1) {
        if (colItem.width) {
          let split = colItem.width.split("/");
          return "flex:" + (split[0] * 12) / (split[1] || 1) + ";";
        } else {
          return "";
        }
      }
      if (length == 1) {
        if (colItem.width) {
          let split = colItem.width.split("/");
          return "width:" + (split[0] * 100) / (split[1] || 1) + "%;";
        } else {
          return "";
        }
      }
    },
    closeSuccAndRefDlg() {
        if(!this.hasModal){
            this.closeDaliogFunc();
        }
      this.succAndRefDlgVs = false
      this.succAndRefDlgData = {
        title: this.succAndRefDlgData.title,
        suggest: '',
        iptIndex: null
      }
      this.suggestBoxVs = false
      this.canSubMit = true
    },
    clsoeOpDlg() {
      this.moreBtnDlgVs = false
      this.moreBtnDlgData.suggest = ''
      this.moreBtnDlgData.iptIndex = null
      this.suggestBoxVs = false
    },
    handleTabClick(tab) {
      if (tab.props.name === 'task' && this.taskCenterTaskId) {
        this.fetchTaskCenterTaskDetail(this.taskCenterTaskId);
      }
    },
    queryCurUserRowAuth(){
        if(this.wtId && this.dtlRowData._id){
            this.$http.post(this.$api.worktbl.queryCurUserRowAuth,{
                wt_id: this.wtId,
                row_id: this.dtlRowData._id
            }).then((res)=>{
                this.userAuth = res.payload ||{
                    "isOwner": false,
                    "rowKnowAuth": {
                        "addKnPage": false,
                        "downloadKnpage": false,
                        "editKnPage": false
                    },
                    "rowDataAuth": {
                        "editCurRow": false
                    }
                };
            })
        }
    },
    isHasTblFlag(){
        let bool = false
        if(this.auditConfig.dealFldsSet && this.succAndRefDlgData.title != '退回到发起人' && this.succAndRefDlgData.title != '退回指定节点'){
            let list = this.auditConfig.dealFldsSet || []
            let listKey = ['RELATETBL','CHILDTBL','QUERYTBL']
            bool = !!list.find((zitem)=>{return listKey.includes((this.fldsList[zitem.fldId] || {}).type)})
            for(let item of this.auditConfig.dealFldsSet || []){
                if((this.fldsList[item.fldId] || {}).type == 'RELATETBL'){
                    this.getRelateSet(((this.fldsList[item.fldId] || {}).attr || {}).relateTblSet.relatedTbl,item.fldId)
                }
            }
        }
        return bool
    },
    toInitRelateList(){
        for(let key of Object.keys(this.flds || {})){
            let item = this.flds[key]
            if(item.type == 'RELATETBL'){
                this.getRelateSet((item.attr || {}).relateTblSet.relatedTbl,key)
            }
        }
    },
    getRelateSet(wtId,fldId){
        if(wtId && !this.relateTblFlds[fldId]){
            this.$http.post(this.$api.worktbl.queryFormDtlStruct, {
                wt_id: wtId,
            }).then((res)=>{
                if(res.payload.wt_flds){
                    this.relateTblFlds[fldId] = JSON.parse(res.payload.wt_flds)
                }
            })
        }
    },
    fetchTaskCenterTaskDetail(taskId) {
      this.$http.post(this.$api.taskCenter.queryTaskDtl, { task_id: taskId }).then(res => {
        this.task = res.payload
        this.task.task_assignId = JSON.parse(this.task.task_assignId)
        this.task.task_chargeId = JSON.parse(this.task.task_chargeId)
        this.task.task_crtEmp = JSON.parse(this.task.task_crtEmp)
        this.task.task_remindRule = JSON.parse(this.task.task_remindRule)
        this.task.task_file=JSON.parse(this.task.task_file||'[]')
        if(this.task.task_relateRow===null || this.task.task_relateRow===undefined){
          this.task.task_relateRow = null
        }
        else{
            this.task.task_relateRow = JSON.parse(this.task.task_relateRow, (key, value) => {
            // 检查是否是数字且超过 MAX_SAFE_INTEGER
            if (typeof value === 'number' && !Number.isSafeInteger(value)) {
              return BigInt(value).toString(); // 转为字符串
            }
            return value;
          });
        }
        if(this.task.task_completeSet===null || this.task.task_completeSet===undefined){
          this.task.task_completeSet = {
            isOpen: false,
            fd_id: '',
            fd_name: '',
          }
        }
        else{
          this.task.task_completeSet = JSON.parse(this.task.task_completeSet)
        }
        if(this.task.task_attach===null || this.task.task_attach===undefined){
          this.task.task_attach = null
        }
        else{
          this.task.task_attach = JSON.parse(this.task.task_attach)
        }
        if(this.task.detail===null||this.task.detail===undefined){
          this.task.detail=''
        }

        this.task.isComplete = this.task.task_status==30
        this.task.task_remindLabel = this.task.task_remindRule.self_label//把藏起来的取出来
        let num1 = parseInt(this.task.task_startTime, 10)
        let num2 = parseInt(this.task.task_dueTime, 10)
        this.task.task_timeArr = [new Date(num1), new Date(num2)]

      });
    },
    formatDate(val) {
      if (!val) return '-';
      const d = new Date(Number(val));
      if (isNaN(d.getTime())) return val;
      return `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} ${d.getHours().toString().padStart(2,'0')}:${d.getMinutes().toString().padStart(2,'0')}`;
    },
    saveTaskExtraData(){
        this.$http.post(this.$api.flow.saveTaskExtraData, { 
            taskId: this.curTaskId,
            hi_task_extraData:{
                more:this.moreBtnDlgData,
                formData:this.editRowData,
                succAndRefDlgData:this.succAndRefDlgData
            }
        }).then(() => {
            this.$message({
                type: 'success',
                message: '暂存成功'
            });
        })
    },
    queryTaskById(){
        return new Promise((resolve)=>{
            if(this.taskId){
                this.$http.post(this.$api.flow.queryTaskById, { 
                    taskId: this.taskId,
                }).then((res) => {
                    this.isAddSign = res.payload['hi_task_isAddSign'] || false
                    let extraData = JSON.parse(res.payload['hi_task_extraData'] || '{}')
                    if(extraData['more']){
                        this.moreBtnDlgData = extraData['more']
                    }
                    if(extraData['formData']){
                        this.editRowData = {...this.editRowData,...extraData['formData']}
                    }
                    if(extraData['succAndRefDlgData']){
                        this.succAndRefDlgData = extraData['succAndRefDlgData']
                    }
                    resolve()
                })
            }else{
                resolve()
            }
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.flowDtlBox_content_box{
  width: calc(100% - 402px);
  height: 100%;
  // padding-top: 20px;
  position: relative;
  border-right: 1px solid #dee0e3;
  box-sizing: border-box;
}
.flowDtlBox_content_contentBox{
  height: fit-content;
  position: relative;
  padding:1px 0px;
  box-sizing: border-box;
    :deep(.el-collapse-item){
        border: none;
    }
    :deep(.el-collapse-item__wrap){
        border: none;
    }
    :deep(.el-collapse-item__header){
        border: none;
    }
    :deep(.el-collapse){
        border: none;
    }
    :deep(.el-collapse-item__header){
        height: 38px;
        border: none;
        background: #ECF4FF;
        border-radius:0;
        border-top: 1px solid #DEE9F8;
        border-bottom: 1px solid #DEE9F8;
        box-sizing:border-box;
        color:#303033;
        font-size:14px;
    }
    :deep(.el-collapse-item__content){
        padding-bottom: 0;
    }
    :deep(.el-collapse-item__arrow){
        display: none;
    }
}
.dialog-header{
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
  position: relative;
  border-radius: 12px 12px 0 0;
  .dialog_header_icon{
    position: absolute;
    right: 30px;
    color: #a3a8af;
    z-index: 9;
    cursor: pointer;
    i{
      font-size: 18px;
    }
  }
  .dialog_paging {
    position: absolute;
    left: 16px;
    font-weight: normal;
    font-size: 14px;
    color:#a3a8af;
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 18px;
    }
  }
}
.flowDtl_box{
  :deep(.el-dialog){
    // height: 90vh;
    position: relative;
    // margin: 0 auto;
    // margin-top: 3vh;
    --el-dialog-border-radius:12px 12px 0 0;
  }
  :deep(.el-overlay-dialog){
    overflow: hidden;
  }
  :deep(.el-dialog__footer){
    box-shadow: 0 3px 10px 0 rgba(48,53,69,0.2);
    padding-bottom: 10px;
  }
}
// ---------
.tableBox{
  display: flex;
  min-height: 40px;
}
.border_box_left{
  border-left: solid 1px #a6a6a6;
}
.border_box_top{
  border-top: solid 1px #a6a6a6;
  border-bottom: solid 1px #a6a6a6;
  border-right: solid 1px #a6a6a6;
  margin-top: -1px;
  margin-left: -1px;
}
.formDesigner_centerBox::-webkit-scrollbar{
  width: 0!important;
}
.domStyle{
  min-height: 40px;
  height: 100%;
  width: 100%;
  padding: 4px 12px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  animation-iteration-count:1;
  -webkit-animation-iteration-count: 1;
}
.domSpanBox{
  height: 100%;
}
.rowStyle{
  width: 100%;
  display: flex;
  position: relative;
}
.colItemStyle{
  width: 100%;
  position: relative;
}
.colItemStyle{
    &:not(:only-child){
        &:first-child{  
            .domStyle{
                padding-left: 24px;  
            }
        }  
        &:last-child{ 
            .domStyle{ 
                padding-right: 24px; 
            }
        }
    }
    &:only-child{
        .domStyle{ 
            padding-left: 24px;  
            padding-right: 24px;
        } 
    }
}
.tabLineBox{
    width: 100%;
    display: flex;
    padding:0;
}
.tabBox_inner_collapse{
    padding: 8px 0;
    width: 100%;
    position: relative;
}
.colorLine_box{
  width: 100%;
  height: 3px;
}
.tabTableBox{
    min-height: 94px;
    padding: 6px 0px;
    border-radius:0 0 4px 4px;
    border-top: none;
    width: 100%;
    background: #fff;
}
.shrinkBox{
    min-height: 40px;
    padding: 10px 0px;
    border-radius: 4px;
    border-top: none;
    width: 100%;
    border-top: 0;
    line-height: initial;
}

.formDesigner_centerBox {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  min-width: 600px;
}
.formDesigner_centerBox_relativeBox{
  position: relative;
}
.formDesigner_lineBox_relativeBox{
  position: relative;
}
.collopase_title_box{
    width: 100%;
    height: 100%;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #575757;
    >div{
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .collapse_icon_box{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    i{
        color: var(--mainColor);
        margin-left:8px;
    }
}
.animoStyle{
  width: 100%;
  position: relative;
}
.formDesigner_centerBox_lineBox{
  padding: 10px 0px;
  position: relative;
}
:deep(.el-tabs__header){
  margin-bottom: 0;
}
:deep(.noAllowCollapse){
  .el-icon{
    display: none;
  }
}
.flowDtlBox_content_slotBox{
  width: 100%;
  :deep(.el-tabs__nav-wrap::after){
      height: 1px;
  }
  :deep(.el-tabs__header) {
    position: relative;
    padding-left: 15px;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: var(--el-border-color-light);
      z-index: var(--el-index-normal);
    }
  }
  :deep(.el-tabs) {
    height: 100%;
  }
  :deep(.el-tabs__content) {
    width: 100%;
    height: calc(100% - 36px);
    // overflow-y: scroll;
    >div {
      height: 100%;
    }
  }
}
:deep(.el-dialog__body){
  padding: 0!important;
}
:deep(.el-dialog__header){
  padding: 0;
}
:deep(.el-dialog__headerbtn){
    top: 0;
}
.flowDtlBox_content{
    height: calc(100vh - 70px);
    display: flex;
    border-top: solid 1px #dee0e3;
    box-sizing: border-box;
}
.flowDtlBox_content_slotBox{
    flex:0 0 400px;
}
.dialog_bottom_btn_box{
  height: 50px;
  width: 100%;
  position:absolute;
  bottom: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-shadow: 0px 3px 10px rgba(48, 53, 69, 0.2);
  .dialog-footer{
    margin-right: 15px;
    .el-button {
      i {
        margin-right: 5px;
      }
      .icon-down-arrow {
        margin-right: 0;
        color: #606266;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
}
:deep(.el-tabs) {
  --el-tabs-header-height: 36px;
}
.formDesigner_lineBox_Nav_Box{
  :deep(.el-tabs__nav-wrap) {
    border-bottom: 1px solid #E1E1E5;
    padding: 0 20px;
    background: #fff;
    border-radius: 3px 3px 0 0;
  }
  :deep(.el-tabs__nav) {
    padding: 4px 0;
    margin-left:12px;
    .is-active{
      background: transparent;
      color: #606066;
    }
  }
  :deep(.el-tabs__nav-wrap)::after{
    background: #E1E1E5;
    height: 1px;
    
  }
}
.formDesigner_lineBox_Tab_Box{
  border: none;
  :deep(.el-tabs__content) {
    margin-top: -1px;
    padding: 0;
    border-top: 1px solid #E1E1E5;
  }
  :deep(.el-tabs__header) {
    background: transparent;
  }
  :deep(.el-tabs__item) {
    border: 1px solid #E1E1E5;
    margin-left: 0!important;
    margin-top: 0!important;
    margin-right: 8px;
    border-radius: 4px 4px 0 0;
    background: #F5F7FC;
    &:not(.is-active){
        color:#525967 !important;
    }
  }
  :deep(.el-tabs__nav) {
    .is-active{
      background: #fff;
      border-bottom-color: #fff;
    }
    &:nth-child(1) {
      margin-left: 12px;
    }
  }
  :deep(.el-tabs__nav-wrap) {
    background: #fff;
    border-radius: 4px 4px 0 0;
  }
}
.moreBtn_list_box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 10px;
  .moreBtn_item {
    width: 92px;
    margin-bottom: 10px;
    i {
      margin-right: 6px;
    }
  }
}
.return_btns {
  padding: 10px 10px 0 10px;
  .moreBtn_item {
    width: fit-content;
  }
}
.flow_status {
  position: absolute;
  top: 30px;
  left: 20px;
  img {
    width: 90px;
  }
}
.long_time_box {
  width: 100%;
  height: 100%;
  padding: 20px;
  padding-right: 12px;
  overflow-y: scroll;
  box-sizing: border-box;
  .long-time-header {
    display: flex;
    height: 16px;
    align-items: center;
    margin-bottom: 29px;
    .long-time-header-title {
        color: #575757;
        font-size: 14px;
        margin-left: 10px;
        font-weight: bold;
    }
  }
  .long_time_list_group {
    .long_time_list_group_title {
      color: #8e8e8e;
      margin-bottom: 13px;
    }
    .long_time_list_item {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 12px;
      background-color: #ffffff;
      box-shadow: 0px 1px 3px 0px rgba(85, 88, 94, 0.4);
      border-radius: 3px;
      justify-content: space-between;
      margin-bottom: 12px;
      .long_time_list_item_left {
        font-size: 14px;
        color: #575757;
        font-weight: bold;
      }
      .long_time_list_item_right {
        font-size: 12px;
        color: #8e8e8e;
      }
    }
  }
}
:deep(.formFld_pcdtlBox){
    width: 100%;
    margin-top:0!important;
}
:deep(.formFld_pcdtlBox_value){
    height: 40px;
    width: calc(100% - 30px)!important;
    padding: 0 15px!important;
    margin-top: 8px!important;
    display: flex;
    align-items: center;
    background:#F5F7FC!important;
}
.dtlForm_leftRight{
    .domStyle{
        padding: 0!important;
    }
    .formDesigner_centerBox_relativeBox{
        >div{
            padding:0 12px;
            width:calc(100% - 24px);
        }
    }
    .colItemStyle{
        border-top: solid 1px #a6a6a6; 
        border-bottom: solid 1px #a6a6a6; 
        border-right: solid 1px #a6a6a6;
        margin-top: -1px;
        margin-left: -1px;
    }
    .animoStyle{
        border-left: solid 1px #a6a6a6;
        height: 100%;
        box-sizing: border-box;
    }
    :deep(.formFld_dtlContent_box){
        display: flex; 
        margin-bottom: 0!important;
        height: 100%;
        .formFld_title{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0;
            color: #575757;
            width: 120px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 0 0 auto;
            font-size: 14px;
            box-sizing: border-box;
            white-space: normal;
            border-right: solid 1px #a6a6a6;
            background-color: #f2f3f5 !important;
            position: relative;
        }
        .formFld_pcdtlBox_value{
            margin-top: 0!important;
            width: 100%!important;
            border-radius: 0;
            box-sizing: border-box;
            background:#FFFFFF!important;
        }
    }
    .formDesigner_centerBox_lineBox{
        padding: 0;
        :deep(.el-collapse){
            border-top: solid 1px #a6a6a6; 
            border-bottom: solid 1px #a6a6a6; 
            border-right: solid 1px #a6a6a6;
            border-left: solid 1px #a6a6a6;
            margin-top: -1px;
            margin-left: -1px;
        }
        :deep(.el-collapse-item__header){
            background: #f2f3f5;
            height: 42px;
            border-bottom: solid 1px #a6a6a6;
        }
    }
    .shrinkBox{
        padding: 0px;
        .tabLineBox{
            padding: 0!important;
            width: calc(100% + 1px)!important;
        }
    }
}

.flowDtl_formBox {
  padding: 0 20px 10px 20px;
  position: relative;
}

.flowDtl_label {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: #303033;
  margin-bottom: 12px;
  margin-top: 24px;
}
.flowDtl_cAndA {
  width: 100%;
  display: flex;
}
.flowDtl_task_chargeId, .flowDtl_task_assignId {
  width: 100%;
}
.flowDtl_userNameSingleBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.flowDtl_userNameSingle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  flex: 0 0 auto;
  color: #ffffff;
  background-color: var(--mainColor);
}
.flowDtl_showMemSelector2 {
  cursor: pointer;
  height: 38px;
  display: flex;
  align-items: center;
  padding-left: 8px;
}
.flowDtl_placeholder {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 15px 0 5px;
  font-size: 13px;
}
.flowDtl_task_time {
  margin-top: 16px;
  .displayflex{
    width:100%;
    :deep(.el-range-editor){
      height: auto;
      padding: 0 10px;
      box-sizing: border-box;
      width:100%;
      padding: 0;
    }
  }
}
.flowDtl_file {
  margin-top: 16px;
  :deep(.main_updown_box){
    margin-bottom: 0;
    .formFld_inputBox{
      border: #dcdfe6 1px solid;
      border-radius: 4px;
    }
  }
}
.flowDtl_task_remindRule{
  margin-right: 10px; 
  width: 100%;
}
.flowDtl_task_star {
  width: 100%;
}
.flowDtl_rAnds {
  width: 100%;
  display: flex;
}
.flowDtl_task_detail {
  margin-top: 16px;
}
.flowDtl_task_detail .el-input__inner, .flowDtl_task_detail .el-textarea__inner {
  background: #f5f7fa;
}
.subTagBG {
  background: #f5f7fa;
}
.flowDtl_tabBox {
  padding: 0px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  height: 45vh;
  overflow: auto;
}
.flowDtl_subTask_text {
  display: flex;
  align-items: center;
  color: #A1A2AB;
  margin: 10px 0 5px 0;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
}
.flowDtl_subTask_Box {
  height: 30px;
  margin: 5px 0 5px 0;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}
.flowDtl_subTask_Box_left {
  display: flex;
  align-items: center;
}
.flowDtl_subTask_titleInput {
  height: 30px;
  outline: none;
  border: none;
  font-size: 14px;
  background-color: transparent;
}
.flowDtl_subTask_Box_right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flowDtl_subTask_Box_right_time {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.flowDtl_userNameSingle2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  flex: 0 0 auto;
  color: #ffffff;
  background-color: var(--mainColor);
}
.flowDtl_task_assignId_disable {
  background: #f5f7fa;
}
:deep(.flowDtl_task_assignId_disable){
  .backgroundWhite {
    background: #f5f7fa;
  }

  .formFld_inputBox:not(.unsetStyle) {
    background: #f5f7fa !important;
    .formFld_file .formFld_file::after {
      content: '';
      display: inline-block;
      margin:0 5px 0 0;
      // color:#f5f7fa;
      // position: relative;
      // top: 25%;
      // transform: translateY(-50%);
  }
  }
}
.flowDtl_block,
.flowDtl_showMemSelector {
  cursor: pointer;
  height: 38px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding-left: 8px;

  .flowDtl_userNameSingleBox {
    display: flex;
    flex-direction: row;
    align-items: center;

    .flowDtl_userNameSingle {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      flex: 0 0 auto;
      color: #ffffff;
      background-color: var(--mainColor);
    }
  }

  .flowDtl_placeholder {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 15px 0 5px;
    color: #b5b7bd;
    font-size: 13px;
  }

}
.flowDtl_file {
  :deep(.formFld_title){
    background-color: #ffffff;
    padding-bottom: 20px;
    margin-bottom: 1px !important;
  }
}
.dialog_box {
  :deep(.el-dialog) {
    .el-dialog__header {
      border-bottom: 1px solid #dee0e3;
      padding-top: 10px;
      padding-bottom: 10px;
      margin-right: 0;
    }
  }
  .dlg_main {
    padding: 10px 20px;
    min-height: 150px;
    max-height: calc(80vh - 123px);
    overflow-y: scroll;
    box-sizing: border-box;
    padding-right: 12px;
    .dlg_item {
      margin-bottom: 20px;
      .dlg_item_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #303033;
        margin-bottom: 10px;
        >p {
          font-weight: bold;
        }
        
      }
      .dlg_item_c {
        :deep(.formFld_title){
            display: none;
        }
        :deep(.formFld_inputBox){
            border: #dcdfe6 1px solid;
            border-radius: 4px;
            background: #fff;
            box-sizing: border-box;
        }
        :deep(.el-radio) {
          height: fit-content;
        }
        .el-select {
          width: 100%;
        }
        .emp_box {
          display: flex;
          align-items: center;
          height: 38px;
          .emp_item {
            position: relative;
            display: flex;
            height: 38px;
            cursor: pointer;
            border-radius: 4px;
            align-items: center;
            box-sizing: border-box;
            margin-right: 6px;
            padding-right: 12px;
            &:hover {
              background-color: #f2f3f5;
              >i {
                display: block;
              }
            }
            .emp_item_pic {
              width: 28px;
              height: 28px;
              line-height: 28px;
              text-align: center;
              background-color: var(--mainColor);
              color: #fff;
              border-radius: 50%;
              margin-right: 8px;
              margin-left: 12px;
            }
            >i {
              display: none;
              position: absolute;
              font-size: 14px;
              color: #858585;
              top: -8px;
              right: -2px;
            }
          }
          .emp_btn {
            display: flex;
            align-items: center;
            cursor: pointer;
            span {
              margin-left: 10px;
              color: #8e8e8e;
            }
          }
        }
      }
      :deep(.formFld_img_showBox_one){
        .formFld_img_showItem{
            max-width: 580px;
        }
      }
    }
  }
  .suggest_box {
    position: relative;
    .suggest_title {
      display: flex;
      align-items: center;
      width: fit-content;
      cursor: pointer;
      color: #8e8e8e;
      i {
        color: #606266;
        font-size: 20px;
        font-weight: bold;
        margin-left: 6px;
      }
    }
    .suggest_list {
      position: absolute;
      top: 25px;
      // left: -30px;
      right: 0;
      width: 200px;
      height: 190px;
      background-color: #ffffff;
      box-shadow: 0px 3px 16px 0px 
          rgba(75, 82, 94, 0.2);
      border-radius: 3px;
      z-index: 22;
      .suggest_list_t {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 12px;
        box-sizing: border-box;
        height: 31px;
        border-bottom: 1px solid #dee0e3;
        font-size: 12px;
        p {
          color: #8e8e8e;
        }
        i {
          font-size: 12px;
          cursor: pointer;
        }
      }
      .suggest_list_c {
        height: calc(100% - 31px);
        overflow-y: scroll;
        padding: 16px;
        padding-right: 8px;
        box-sizing: border-box;
        .suggest_item {
          height: 22px;
          background-color: #f2f3f5;
          border-radius: 3px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-left:  6px;
          font-size: 12px;
          line-height: 22px;
          margin-bottom: 11px;
          cursor: pointer;
          &:hover {
            background: var(--lightColor);
            color: var(--mainColor);
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.btn_popover {
  padding: 0 !important;
  min-width: 100px !important;
  width: 110px !important;
}
.return_popover {
  padding: 0 !important;
  width: 170px !important;
}

.flowDtlBox_content_slotBox {
  height: 100%;
  max-height: 100%;

}
.dialog_footer{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .dialog_footer_checkbox{
        position: absolute;
        right: 0px;
    }
}
</style>
